import { TerminalDesignTokens } from '@primeuix/themes/types/terminal';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/terminal/index.ts
const term = componentCommon.terminal;
const d = tDeep(term);

export const TerminalTelekomDT: TerminalDesignTokens = {
  root: {
    background: t(term.background),
    color: t(term.color),
    height: t(term.height),
    borderColor: t(term.border.color),
    borderRadius: t(term.border.radius),
    padding: `${d.padding.y} ${d.padding.x}`,
  },
  prompt: {
    gap: t(term.prompt.gap),
  },
  commandResponse: {
    margin: `${d.command.response.margin.y} ${d.command.response.margin.x}`,
  },
};
